module.exports = __webpack_public_path__ + "img/sort_active.3ab0788c.svg";